import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as registrationActions from '../../actions/registrationActions';
import * as sessionActions from '../../actions/sessionActions';
import * as profileActions from '../../actions/profileActions';
import * as policyActions from '../../actions/policyActions';
import { push } from 'connected-react-router';
import { registrationSelector, sessionSelector } from '../../selectors';

import { Container, Grid, Header, Button } from 'semantic-ui-react';
import { PolicyVerification, UserRegistration, StaffPolicyVerification, TermsModal, RegistrationComplete } from '../../components/auth';
import VMasker from 'vanilla-masker';

class RegistrationPage extends Component {
	constructor(props) {
		super(props);

		this.state = { showTerms: false, registrationComplete: false };
		this.onVerify = this.onVerify.bind(this);
		this.onVerifyFieldChange = this.onVerifyFieldChange.bind(this);
		this.onCreate = this.onCreate.bind(this);
		this.onCreateFieldChange = this.onCreateFieldChange.bind(this);
		this.onTryAgain = this.onTryAgain.bind(this);
		this.onVerifyByStaff = this.onVerifyByStaff.bind(this);
		this.onVerifyByStaffCompleted = this.onVerifyByStaffCompleted.bind(this);
		this.onShowTerms = this.onShowTerms.bind(this);
		this.onHideTerms = this.onHideTerms.bind(this);
	}

	componentDidMount() {
		const { location, actions, registration } = this.props;
		const { policy } = registration;

		var searchParams = new URLSearchParams(location.search);
		var newPolicy = { ...policy };

		var policyNumber = searchParams.get('policyNumber');
		if (policyNumber) {
			newPolicy.policyNumber = policyNumber;
		}

		var policyHolder = searchParams.get('policyHolder');
		if (policyHolder) {
			newPolicy.policyHolder = policyHolder;
		}
		actions.updatePolicyRegistration(newPolicy);
	}

	onVerify(e) {
		const policy = { ...this.props.registration.policy };
		if (policy.verifiedPart1) {
			return this.props.actions.verifyFullPolicy(policy);
		}

		this.props.actions.verifyPolicy(policy);
	}

	onVerifyFieldChange(e) {
		const policy = { ...this.props.registration.policy };

		if (e.target.name === 'staffVerificationPhoneNumber') {
			VMasker(e.target).maskPattern('999-999-9999');
		}

		if (e.target.name === 'driversLicenseNumber') {
			VMasker(e.target).maskPattern('SSSSSSSSSSSS');
		}

		policy[e.target.name] = e.target.value;

		if (e.target.name === 'zip') {
			//VMasker(e.target).maskNumber();
			policy[e.target.name] = e.target.value.replace(/[a-zA-Z]/g,'');
		}
		this.props.actions.updatePolicyRegistration(policy);
	}

	onShowTerms(e) {
		e.preventDefault();
		this.setState({ showTerms: true });
	}

	onHideTerms(e) {
		e.preventDefault();
		this.setState({ showTerms: false });
	}

	async onCreate(e) {
		const { policy } = this.props.registration;

		const user = { ...this.props.registration.user };
		user.policyNumber = policy.policyNumber;
		user.policyHolder = policy.policyHolder;
		try {
			await this.props.actions.registerUser(user);
			this.setState({ registrationComplete: true });
		} catch (error) {
			throw error;
		}
	}

	onCreateFieldChange(e, data) {
		const user = { ...this.props.registration.user };
		if (!e.target.name) {
			user[data.name] = data.checked;
		} else {
			user[e.target.name] = e.target.value;
		}
		this.props.actions.updateUserRegistration(user);
	}

	onTryAgain(e) {
		this.props.actions.updateRequireStaffVerification(false);
	}

	onVerifyByStaff(e) {
		const policy = { ...this.props.registration.policy };
		if (policy.requiresStaffVerification) {
			const policy = { ...this.props.registration.policy };
			return this.props.actions.verifyByStaff(policy);
		}
	}

	onVerifyByStaffCompleted() {
		// take home
		const { actions } = this.props;
		actions.push('/');
	}

	render() {
		const { policy, user } = this.props.registration;
		const { showTerms, registrationComplete } = this.state;

		let currentWorkflow;
		if (!(policy.verifiedPart1 && policy.verifiedPart2)) currentWorkflow = <PolicyVerification onSubmit={this.onVerify} onChange={this.onVerifyFieldChange} loading={policy.loading} error={policy.error} data={policy} />;

		if (policy.verifiedPart1 && policy.verifiedPart2 && policy.requiresStaffVerification === false) currentWorkflow = <UserRegistration onSubmit={this.onCreate} onChange={this.onCreateFieldChange} loading={user.loading} error={user.error} data={user} onShowTerms={this.onShowTerms} />;

		if (policy.requiresStaffVerification) currentWorkflow = <StaffPolicyVerification onSubmit={this.onVerifyByStaff} onTryAgain={this.onTryAgain} onChange={this.onVerifyFieldChange} loading={policy.loading} error={policy.error} data={policy} allowTryAgain={policy.registrationFailureCount < 3} />;

		if (policy.staffVerificationRequestCompleted)
			currentWorkflow = (
				<div>
					<Header as='h1' textAlign='center' content="What's next?" />
					<Header as='h4' content='We apologize for any inconvenience, but we need a staff member to validate the information provided.  The validation may take until the end of the next business day.  Once completed, you will receive a confirmation email that will contain a link to access your new account.' />
					<Header as='h4' content='Questions? Please contact Customer Service at 800.477.1660.' />
					<Button basic fluid type='button' onClick={this.onVerifyByStaffCompleted}>
						OK
					</Button>
				</div>
			);

		if (registrationComplete) currentWorkflow = <RegistrationComplete />;

		return (
			<div className='auth register'>
				<TermsModal open={showTerms} onClose={this.onHideTerms} />
				<Container>
					<Grid columns='equal'>
						<Grid.Column width={7} only='tablet computer' />
						<Grid.Column computer={8} mobile={16} tablet={8}>
							{currentWorkflow}
						</Grid.Column>
					</Grid>
				</Container>
			</div>
		);
	}
}

RegistrationPage.propTypes = {
	registration: PropTypes.object.isRequired,
	session: PropTypes.object.isRequired,
	actions: PropTypes.object.isRequired,
};

const mapStateToProps = (state, ownProps) => {
	return {
		session: sessionSelector(state),
		registration: registrationSelector(state),
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		actions: {
			...bindActionCreators(registrationActions, dispatch),
			...bindActionCreators(profileActions, dispatch),
			...bindActionCreators(policyActions, dispatch),
			...bindActionCreators(sessionActions, dispatch),
			...bindActionCreators({ push }, dispatch),
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationPage);
